import { VisuallyHidden } from "@react-aria/visually-hidden";
import { useTable, useTableCell, useTableColumnHeader, useTableRow, useTableRowGroup, useTableRowHeader, useTableSelectAllCheckbox, useTableSelectionCheckbox } from "@react-aria/table";
import { useProvider, useProviderProps } from "@react-spectrum/provider";
import { useLocale, useMessageFormatter } from "@react-aria/i18n";
import { useHover } from "@react-aria/interactions";
import { Tooltip, TooltipTrigger } from "@react-spectrum/tooltip";
import { TableLayout } from "@react-stately/layout";
import { useVirtualizerState } from "@react-stately/virtualizer";
import _react, { useCallback, useContext, useMemo, useRef } from "react";
import { ProgressCircle } from "@react-spectrum/progress";
import { mergeProps } from "@react-aria/utils";
import { layoutInfoToStyle, ScrollView, setScrollLeft, useVirtualizer, VirtualizerItem } from "@react-aria/virtualizer";
import { FocusRing, useFocusRing } from "@react-aria/focus";
import { classNames, useDOMRef, useStyleProps } from "@react-spectrum/utils";
import { Checkbox } from "@react-spectrum/checkbox";
import _spectrumIconsUiArrowDownSmall from "@spectrum-icons/ui/ArrowDownSmall";
import _babelRuntimeHelpersEsmInteropRequireDefault from "@babel/runtime/helpers/esm/interopRequireDefault";
import _babelRuntimeHelpersEsmExtends from "@babel/runtime/helpers/esm/extends";
import _babelRuntimeHelpersEsmObjectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { Column as _Column, TableHeader, TableBody, Section, Row, Cell, useTableState } from "@react-stately/table";
export { Cell, Row, Section, TableBody, TableHeader };
import "./main.css";

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

// ASSET: /Users/govett/dev/react-spectrum-v3/node_modules/@adobe/spectrum-css-temp/components/table/vars.css
var $a3c51db49654cc69b601457d58d38b1$exports = {};
$a3c51db49654cc69b601457d58d38b1$exports = {
  "spectrum-Table": "_spectrum-Table_60175",
  "spectrum-Table-sortedIcon": "_spectrum-Table-sortedIcon_60175",
  "spectrum-Table-headCell": "_spectrum-Table-headCell_60175",
  "is-sortable": "_is-sortable_60175",
  "is-sorted-asc": "_is-sorted-asc_60175",
  "is-sorted-desc": "_is-sorted-desc_60175",
  "spectrum-Table-cell--alignCenter": "_spectrum-Table-cell--alignCenter_60175",
  "spectrum-Table-cell--alignEnd": "_spectrum-Table-cell--alignEnd_60175",
  "spectrum-Table-body": "_spectrum-Table-body_60175",
  "is-drop-target": "_is-drop-target_60175",
  "spectrum-Table-row": "_spectrum-Table-row_60175",
  "spectrum-Table--quiet": "_spectrum-Table--quiet_60175",
  "spectrum-Table-cell": "_spectrum-Table-cell_60175",
  "spectrum-Table--compact": "_spectrum-Table--compact_60175",
  "spectrum-Table--spacious": "_spectrum-Table--spacious_60175",
  "spectrum-Table-cellContents": "_spectrum-Table-cellContents_60175",
  "spectrum-Table-cell--hideHeader": "_spectrum-Table-cell--hideHeader_60175",
  "spectrum-Table--wrap": "_spectrum-Table--wrap_60175",
  "focus-ring": "_focus-ring_60175",
  "is-focused": "_is-focused_60175",
  "spectrum-Table-cell--divider": "_spectrum-Table-cell--divider_60175",
  "spectrum-Table-checkboxCell": "_spectrum-Table-checkboxCell_60175",
  "spectrum-Table-checkbox": "_spectrum-Table-checkbox_60175",
  "is-hovered": "_is-hovered_60175",
  "spectrum-Table-cellWrapper": "_spectrum-Table-cellWrapper_60175",
  "is-disabled": "_is-disabled_60175",
  "is-selected": "_is-selected_60175"
};
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/table/src/table.css
var $ff2ec5d6c962adaac3d6b55fa22b824a$exports = {};
$ff2ec5d6c962adaac3d6b55fa22b824a$exports = {
  "react-spectrum-Table": "_react-spectrum-Table_6d292",
  "react-spectrum-Table-cell": "_react-spectrum-Table-cell_6d292",
  "react-spectrum-Table-cellWrapper": "_react-spectrum-Table-cellWrapper_6d292",
  "react-spectrum-Table-cell--alignCenter": "_react-spectrum-Table-cell--alignCenter_6d292",
  "react-spectrum-Table-cell--alignEnd": "_react-spectrum-Table-cell--alignEnd_6d292",
  "react-spectrum-Table-centeredWrapper": "_react-spectrum-Table-centeredWrapper_6d292"
};
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/table/intl/ar-AE.json
var $fbbf178ad98962c17de04aff58a37fed$exports = {};
$fbbf178ad98962c17de04aff58a37fed$exports = JSON.parse("{\"loading\":\"جار التحميل...\",\"loadingMore\":\"Loading more...\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/table/intl/bg-BG.json
var $ac663f919c089e0e74c4c6df7a16a96$exports = {};
$ac663f919c089e0e74c4c6df7a16a96$exports = JSON.parse("{\"loading\":\"Зареждане...\",\"loadingMore\":\"Зареждане на още...\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/table/intl/cs-CZ.json
var $d68e79ec364a535136ceb0d58520735$exports = {};
$d68e79ec364a535136ceb0d58520735$exports = JSON.parse("{\"loading\":\"Načítání...\",\"loadingMore\":\"Načítání dalších...\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/table/intl/da-DK.json
var $c67e2f1cc0d84451cee53b15727eb0f6$exports = {};
$c67e2f1cc0d84451cee53b15727eb0f6$exports = JSON.parse("{\"loading\":\"Indlæser ...\",\"loadingMore\":\"Indlæser flere ...\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/table/intl/de-DE.json
var $a62ff5e387106ff8457224bbc2d90c4$exports = {};
$a62ff5e387106ff8457224bbc2d90c4$exports = JSON.parse("{\"loading\":\"Laden...\",\"loadingMore\":\"Mehr laden ...\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/table/intl/el-GR.json
var $ec53eeb4b0427e178c069ba312e01f5a$exports = {};
$ec53eeb4b0427e178c069ba312e01f5a$exports = JSON.parse("{\"loading\":\"Φόρτωση...\",\"loadingMore\":\"Φόρτωση περισσότερων...\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/table/intl/en-US.json
var $fc6d6cc683dc1adce0851ceb68a941e$exports = {};
$fc6d6cc683dc1adce0851ceb68a941e$exports = JSON.parse("{\"loading\":\"Loading…\",\"loadingMore\":\"Loading more…\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/table/intl/es-ES.json
var $e01566063f3850c366745084ee9f8d69$exports = {};
$e01566063f3850c366745084ee9f8d69$exports = JSON.parse("{\"loading\":\"Cargando…\",\"loadingMore\":\"Cargando más…\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/table/intl/et-EE.json
var $e43ff2e4d7306d314fbe859178f3$exports = {};
$e43ff2e4d7306d314fbe859178f3$exports = JSON.parse("{\"loading\":\"Laadimine...\",\"loadingMore\":\"Laadi rohkem...\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/table/intl/fi-FI.json
var $c27342b2bf46c95172710d3f806aa777$exports = {};
$c27342b2bf46c95172710d3f806aa777$exports = JSON.parse("{\"loading\":\"Ladataan…\",\"loadingMore\":\"Ladataan lisää…\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/table/intl/fr-FR.json
var $cc37ab0a89dc7196b5c59f44a34eec49$exports = {};
$cc37ab0a89dc7196b5c59f44a34eec49$exports = JSON.parse("{\"loading\":\"Chargement...\",\"loadingMore\":\"Chargement supplémentaire...\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/table/intl/he-IL.json
var $aa1e5f5fe4cea93d6686a1c13d86$exports = {};
$aa1e5f5fe4cea93d6686a1c13d86$exports = JSON.parse("{\"loading\":\"טוען...\",\"loadingMore\":\"טוען עוד...\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/table/intl/hr-HR.json
var $e62697d130b07cf792f63294e74c819$exports = {};
$e62697d130b07cf792f63294e74c819$exports = JSON.parse("{\"loading\":\"Učitavam...\",\"loadingMore\":\"Učitavam još...\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/table/intl/hu-HU.json
var $b40ada75ede223e1b777786509cdc20$exports = {};
$b40ada75ede223e1b777786509cdc20$exports = JSON.parse("{\"loading\":\"Betöltés folyamatban…\",\"loadingMore\":\"Továbbiak betöltése folyamatban…\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/table/intl/it-IT.json
var $c7a23c834dcf11720cfccdb79313214$exports = {};
$c7a23c834dcf11720cfccdb79313214$exports = JSON.parse("{\"loading\":\"Caricamento...\",\"loadingMore\":\"Caricamento altri...\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/table/intl/ja-JP.json
var $fbb803f35fea5f7eba3830aa5235b34d$exports = {};
$fbb803f35fea5f7eba3830aa5235b34d$exports = JSON.parse("{\"loading\":\"読み込み中...\",\"loadingMore\":\"さらに読み込み中...\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/table/intl/ko-KR.json
var $e90a9b92f07b105723521a8cb6e2a23$exports = {};
$e90a9b92f07b105723521a8cb6e2a23$exports = JSON.parse("{\"loading\":\"로드 중\",\"loadingMore\":\"추가 로드 중\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/table/intl/lt-LT.json
var $c6d81db4bf1ad776e61f151ba3e2e37$exports = {};
$c6d81db4bf1ad776e61f151ba3e2e37$exports = JSON.parse("{\"loading\":\"Įkeliama...\",\"loadingMore\":\"Įkeliama daugiau...\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/table/intl/lv-LV.json
var $ca97c1861d6c6ddd4bad1b86b339631$exports = {};
$ca97c1861d6c6ddd4bad1b86b339631$exports = JSON.parse("{\"loading\":\"Notiek ielāde...\",\"loadingMore\":\"Tiek ielādēts vēl...\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/table/intl/nb-NO.json
var $c3a70d8cddc80135e8a506fe0d1fbfe5$exports = {};
$c3a70d8cddc80135e8a506fe0d1fbfe5$exports = JSON.parse("{\"loading\":\"Laster inn ...\",\"loadingMore\":\"Laster inn flere ...\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/table/intl/nl-NL.json
var $ca30b6d9fc3feab49369cf446dda2c$exports = {};
$ca30b6d9fc3feab49369cf446dda2c$exports = JSON.parse("{\"loading\":\"Laden...\",\"loadingMore\":\"Meer laden...\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/table/intl/pl-PL.json
var $d036b29c23927c12b9897bcdd53734ac$exports = {};
$d036b29c23927c12b9897bcdd53734ac$exports = JSON.parse("{\"loading\":\"Ładowanie...\",\"loadingMore\":\"Wczytywanie większej liczby...\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/table/intl/pt-BR.json
var $e0e635a40dd0923c39ee62e6b75a27f4$exports = {};
$e0e635a40dd0923c39ee62e6b75a27f4$exports = JSON.parse("{\"loading\":\"Carregando...\",\"loadingMore\":\"Carregando mais...\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/table/intl/ro-RO.json
var $b21bf8e41811b0e38f4146be4b4015b4$exports = {};
$b21bf8e41811b0e38f4146be4b4015b4$exports = JSON.parse("{\"loading\":\"Se încarcă...\",\"loadingMore\":\"Se încarcă mai multe...\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/table/intl/ru-RU.json
var $ddea3d0de1adcb727c6b5c5f109eb1e3$exports = {};
$ddea3d0de1adcb727c6b5c5f109eb1e3$exports = JSON.parse("{\"loading\":\"Загрузка...\",\"loadingMore\":\"Дополнительная загрузка...\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/table/intl/sk-SK.json
var $d6a892041759178c057b8710b4$exports = {};
$d6a892041759178c057b8710b4$exports = JSON.parse("{\"loading\":\"Načítava sa...\",\"loadingMore\":\"Načítava sa viac...\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/table/intl/sl-SI.json
var $a74b4a3673a46f8f1061bf2fa2b3501$exports = {};
$a74b4a3673a46f8f1061bf2fa2b3501$exports = JSON.parse("{\"loading\":\"Nalaganje...\",\"loadingMore\":\"Nalaganje več vsebine...\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/table/intl/sr-SP.json
var $e526eabafd6e974875dbcda88c1924$exports = {};
$e526eabafd6e974875dbcda88c1924$exports = JSON.parse("{\"loading\":\"Učitavam...\",\"loadingMore\":\"Učitavam još...\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/table/intl/sv-SE.json
var $c44b24cb625df93f587c27eeffb0517d$exports = {};
$c44b24cb625df93f587c27eeffb0517d$exports = JSON.parse("{\"loading\":\"Läser in...\",\"loadingMore\":\"Läser in mer...\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/table/intl/tr-TR.json
var $c2aa7f81d73af2aafaa9116be6db1$exports = {};
$c2aa7f81d73af2aafaa9116be6db1$exports = JSON.parse("{\"loading\":\"Yükleniyor...\",\"loadingMore\":\"Daha fazla yükleniyor...\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/table/intl/uk-UA.json
var $be81ca81a6698c35b6cd81fed48062$exports = {};
$be81ca81a6698c35b6cd81fed48062$exports = JSON.parse("{\"loading\":\"Завантаження…\",\"loadingMore\":\"Завантаження інших об’єктів...\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/table/intl/zh-CN.json
var $d803cac4a04cc182d2cad947f9383948$exports = {};
$d803cac4a04cc182d2cad947f9383948$exports = JSON.parse("{\"loading\":\"正在加载...\",\"loadingMore\":\"正在加载更多...\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/table/intl/zh-TW.json
var $b6ff5eddd3bab4c301dee64acec8e849$exports = {};
$b6ff5eddd3bab4c301dee64acec8e849$exports = JSON.parse("{\"loading\":\"正在載入\",\"loadingMore\":\"正在載入更多...\"}");
// @ts-ignore
const $a50a0490fb3d3795fbda1694977ae526$var$intlMessages = {
  "ar-AE": _babelRuntimeHelpersEsmInteropRequireDefault($fbbf178ad98962c17de04aff58a37fed$exports).default,
  "bg-BG": _babelRuntimeHelpersEsmInteropRequireDefault($ac663f919c089e0e74c4c6df7a16a96$exports).default,
  "cs-CZ": _babelRuntimeHelpersEsmInteropRequireDefault($d68e79ec364a535136ceb0d58520735$exports).default,
  "da-DK": _babelRuntimeHelpersEsmInteropRequireDefault($c67e2f1cc0d84451cee53b15727eb0f6$exports).default,
  "de-DE": _babelRuntimeHelpersEsmInteropRequireDefault($a62ff5e387106ff8457224bbc2d90c4$exports).default,
  "el-GR": _babelRuntimeHelpersEsmInteropRequireDefault($ec53eeb4b0427e178c069ba312e01f5a$exports).default,
  "en-US": _babelRuntimeHelpersEsmInteropRequireDefault($fc6d6cc683dc1adce0851ceb68a941e$exports).default,
  "es-ES": _babelRuntimeHelpersEsmInteropRequireDefault($e01566063f3850c366745084ee9f8d69$exports).default,
  "et-EE": _babelRuntimeHelpersEsmInteropRequireDefault($e43ff2e4d7306d314fbe859178f3$exports).default,
  "fi-FI": _babelRuntimeHelpersEsmInteropRequireDefault($c27342b2bf46c95172710d3f806aa777$exports).default,
  "fr-FR": _babelRuntimeHelpersEsmInteropRequireDefault($cc37ab0a89dc7196b5c59f44a34eec49$exports).default,
  "he-IL": _babelRuntimeHelpersEsmInteropRequireDefault($aa1e5f5fe4cea93d6686a1c13d86$exports).default,
  "hr-HR": _babelRuntimeHelpersEsmInteropRequireDefault($e62697d130b07cf792f63294e74c819$exports).default,
  "hu-HU": _babelRuntimeHelpersEsmInteropRequireDefault($b40ada75ede223e1b777786509cdc20$exports).default,
  "it-IT": _babelRuntimeHelpersEsmInteropRequireDefault($c7a23c834dcf11720cfccdb79313214$exports).default,
  "ja-JP": _babelRuntimeHelpersEsmInteropRequireDefault($fbb803f35fea5f7eba3830aa5235b34d$exports).default,
  "ko-KR": _babelRuntimeHelpersEsmInteropRequireDefault($e90a9b92f07b105723521a8cb6e2a23$exports).default,
  "lt-LT": _babelRuntimeHelpersEsmInteropRequireDefault($c6d81db4bf1ad776e61f151ba3e2e37$exports).default,
  "lv-LV": _babelRuntimeHelpersEsmInteropRequireDefault($ca97c1861d6c6ddd4bad1b86b339631$exports).default,
  "nb-NO": _babelRuntimeHelpersEsmInteropRequireDefault($c3a70d8cddc80135e8a506fe0d1fbfe5$exports).default,
  "nl-NL": _babelRuntimeHelpersEsmInteropRequireDefault($ca30b6d9fc3feab49369cf446dda2c$exports).default,
  "pl-PL": _babelRuntimeHelpersEsmInteropRequireDefault($d036b29c23927c12b9897bcdd53734ac$exports).default,
  "pt-BR": _babelRuntimeHelpersEsmInteropRequireDefault($e0e635a40dd0923c39ee62e6b75a27f4$exports).default,
  "ro-RO": _babelRuntimeHelpersEsmInteropRequireDefault($b21bf8e41811b0e38f4146be4b4015b4$exports).default,
  "ru-RU": _babelRuntimeHelpersEsmInteropRequireDefault($ddea3d0de1adcb727c6b5c5f109eb1e3$exports).default,
  "sk-SK": _babelRuntimeHelpersEsmInteropRequireDefault($d6a892041759178c057b8710b4$exports).default,
  "sl-SI": _babelRuntimeHelpersEsmInteropRequireDefault($a74b4a3673a46f8f1061bf2fa2b3501$exports).default,
  "sr-SP": _babelRuntimeHelpersEsmInteropRequireDefault($e526eabafd6e974875dbcda88c1924$exports).default,
  "sv-SE": _babelRuntimeHelpersEsmInteropRequireDefault($c44b24cb625df93f587c27eeffb0517d$exports).default,
  "tr-TR": _babelRuntimeHelpersEsmInteropRequireDefault($c2aa7f81d73af2aafaa9116be6db1$exports).default,
  "uk-UA": _babelRuntimeHelpersEsmInteropRequireDefault($be81ca81a6698c35b6cd81fed48062$exports).default,
  "zh-CN": _babelRuntimeHelpersEsmInteropRequireDefault($d803cac4a04cc182d2cad947f9383948$exports).default,
  "zh-TW": _babelRuntimeHelpersEsmInteropRequireDefault($b6ff5eddd3bab4c301dee64acec8e849$exports).default
};
const $a50a0490fb3d3795fbda1694977ae526$var$DEFAULT_HEADER_HEIGHT = {
  medium: 34,
  large: 40
};
const $a50a0490fb3d3795fbda1694977ae526$var$DEFAULT_HIDE_HEADER_CELL_WIDTH = {
  medium: 36,
  large: 44
};
const $a50a0490fb3d3795fbda1694977ae526$var$ROW_HEIGHTS = {
  compact: {
    medium: 32,
    large: 40
  },
  regular: {
    medium: 40,
    large: 50
  },
  spacious: {
    medium: 48,
    large: 60
  }
};
const $a50a0490fb3d3795fbda1694977ae526$var$SELECTION_CELL_DEFAULT_WIDTH = 55;

const $a50a0490fb3d3795fbda1694977ae526$var$TableContext = _react.createContext(null);

function $a50a0490fb3d3795fbda1694977ae526$var$useTableContext() {
  return useContext($a50a0490fb3d3795fbda1694977ae526$var$TableContext);
}

var $a3c51db49654cc69b601457d58d38b1$$interop$default = $parcel$interopDefault($a3c51db49654cc69b601457d58d38b1$exports);
var $ff2ec5d6c962adaac3d6b55fa22b824a$$interop$default = $parcel$interopDefault($ff2ec5d6c962adaac3d6b55fa22b824a$exports);

function $a50a0490fb3d3795fbda1694977ae526$var$Table(props, ref) {
  props = useProviderProps(props);
  let {
    isQuiet
  } = props;
  let {
    styleProps
  } = useStyleProps(props);
  let state = useTableState(_babelRuntimeHelpersEsmExtends({}, props, {
    showSelectionCheckboxes: true
  }));
  let domRef = useDOMRef(ref);
  let formatMessage = useMessageFormatter($a50a0490fb3d3795fbda1694977ae526$var$intlMessages);
  let {
    scale
  } = useProvider();
  let density = props.density || 'regular';
  let layout = useMemo(() => new TableLayout({
    // If props.rowHeight is auto, then use estimated heights based on scale, otherwise use fixed heights.
    rowHeight: props.overflowMode === 'wrap' ? null : $a50a0490fb3d3795fbda1694977ae526$var$ROW_HEIGHTS[density][scale],
    estimatedRowHeight: props.overflowMode === 'wrap' ? $a50a0490fb3d3795fbda1694977ae526$var$ROW_HEIGHTS[density][scale] : null,
    headingHeight: props.overflowMode === 'wrap' ? null : $a50a0490fb3d3795fbda1694977ae526$var$DEFAULT_HEADER_HEIGHT[scale],
    estimatedHeadingHeight: props.overflowMode === 'wrap' ? $a50a0490fb3d3795fbda1694977ae526$var$DEFAULT_HEADER_HEIGHT[scale] : null,
    getDefaultWidth: (_ref) => {
      let {
        hideHeader,
        isSelectionCell,
        showDivider
      } = _ref;

      if (hideHeader) {
        let width = $a50a0490fb3d3795fbda1694977ae526$var$DEFAULT_HIDE_HEADER_CELL_WIDTH[scale];
        return showDivider ? width + 1 : width;
      } else if (isSelectionCell) {
        return $a50a0490fb3d3795fbda1694977ae526$var$SELECTION_CELL_DEFAULT_WIDTH;
      }
    }
  }), [props.overflowMode, scale, density]);
  let {
    direction
  } = useLocale();
  layout.collection = state.collection;
  let {
    gridProps
  } = useTable(_babelRuntimeHelpersEsmExtends({}, props, {
    ref: domRef,
    isVirtualized: true,
    layout
  }), state); // This overrides collection view's renderWrapper to support DOM heirarchy.

  let renderWrapper = (parent, reusableView, children, renderChildren) => {
    let style = layoutInfoToStyle(reusableView.layoutInfo, direction, parent && parent.layoutInfo);

    if (style.overflow === 'hidden') {
      style.overflow = 'visible'; // needed to support position: sticky
    }

    if (reusableView.viewType === 'rowgroup') {
      return /*#__PURE__*/_react.createElement($a50a0490fb3d3795fbda1694977ae526$var$TableRowGroup, {
        key: reusableView.key,
        style: style
      }, renderChildren(children));
    }

    if (reusableView.viewType === 'header') {
      return /*#__PURE__*/_react.createElement($a50a0490fb3d3795fbda1694977ae526$var$TableHeader, {
        key: reusableView.key,
        style: style
      }, renderChildren(children));
    }

    if (reusableView.viewType === 'row') {
      return /*#__PURE__*/_react.createElement($a50a0490fb3d3795fbda1694977ae526$var$TableRow, {
        key: reusableView.key,
        item: reusableView.content,
        style: style
      }, renderChildren(children));
    }

    if (reusableView.viewType === 'headerrow') {
      return /*#__PURE__*/_react.createElement($a50a0490fb3d3795fbda1694977ae526$var$TableHeaderRow, {
        key: reusableView.key,
        style: style,
        item: reusableView.content
      }, renderChildren(children));
    }

    return /*#__PURE__*/_react.createElement(VirtualizerItem, {
      key: reusableView.key,
      reusableView: reusableView,
      parent: parent,
      className: classNames($a3c51db49654cc69b601457d58d38b1$$interop$default, 'spectrum-Table-cellWrapper', classNames($ff2ec5d6c962adaac3d6b55fa22b824a$$interop$default, {
        'react-spectrum-Table-cellWrapper': !reusableView.layoutInfo.estimatedSize
      }))
    });
  };

  let renderView = (type, item) => {
    switch (type) {
      case 'header':
      case 'rowgroup':
      case 'section':
      case 'row':
      case 'headerrow':
        return null;

      case 'cell':
        {
          if (item.props.isSelectionCell) {
            return /*#__PURE__*/_react.createElement($a50a0490fb3d3795fbda1694977ae526$var$TableCheckboxCell, {
              cell: item
            });
          }

          if (state.collection.rowHeaderColumnKeys.has(item.column.key)) {
            return /*#__PURE__*/_react.createElement($a50a0490fb3d3795fbda1694977ae526$var$TableRowHeader, {
              cell: item
            });
          }

          return /*#__PURE__*/_react.createElement($a50a0490fb3d3795fbda1694977ae526$var$TableCell, {
            cell: item
          });
        }

      case 'placeholder':
        // TODO: move to react-aria?
        return /*#__PURE__*/_react.createElement("div", {
          role: "gridcell",
          "aria-colindex": item.index + 1,
          "aria-colspan": item.colspan > 1 ? item.colspan : null
        });

      case 'column':
        if (item.props.isSelectionCell) {
          return /*#__PURE__*/_react.createElement($a50a0490fb3d3795fbda1694977ae526$var$TableSelectAllCell, {
            column: item
          });
        }

        if (item.props.hideHeader) {
          return /*#__PURE__*/_react.createElement(TooltipTrigger, {
            placement: "top",
            trigger: "focus"
          }, /*#__PURE__*/_react.createElement($a50a0490fb3d3795fbda1694977ae526$var$TableColumnHeader, {
            column: item
          }), /*#__PURE__*/_react.createElement(Tooltip, {
            placement: "top"
          }, item.rendered));
        }

        return /*#__PURE__*/_react.createElement($a50a0490fb3d3795fbda1694977ae526$var$TableColumnHeader, {
          column: item
        });

      case 'loader':
        return /*#__PURE__*/_react.createElement($a50a0490fb3d3795fbda1694977ae526$var$CenteredWrapper, null, /*#__PURE__*/_react.createElement(ProgressCircle, {
          isIndeterminate: true,
          "aria-label": state.collection.size > 0 ? formatMessage('loadingMore') : formatMessage('loading')
        }));

      case 'empty':
        {
          let emptyState = props.renderEmptyState ? props.renderEmptyState() : null;

          if (emptyState == null) {
            return null;
          }

          return /*#__PURE__*/_react.createElement($a50a0490fb3d3795fbda1694977ae526$var$CenteredWrapper, null, emptyState);
        }
    }
  };

  return /*#__PURE__*/_react.createElement($a50a0490fb3d3795fbda1694977ae526$var$TableContext.Provider, {
    value: state
  }, /*#__PURE__*/_react.createElement($a50a0490fb3d3795fbda1694977ae526$var$TableVirtualizer, _babelRuntimeHelpersEsmExtends({}, gridProps, styleProps, {
    className: classNames($a3c51db49654cc69b601457d58d38b1$$interop$default, 'spectrum-Table', "spectrum-Table--" + density, {
      'spectrum-Table--quiet': isQuiet,
      'spectrum-Table--wrap': props.overflowMode === 'wrap'
    }, classNames($ff2ec5d6c962adaac3d6b55fa22b824a$$interop$default, 'react-spectrum-Table')),
    layout: layout,
    collection: state.collection,
    focusedKey: state.selectionManager.focusedKey,
    renderView: renderView,
    renderWrapper: renderWrapper,
    domRef: domRef
  })));
} // This is a custom Virtualizer that also has a header that syncs its scroll position with the body.


function $a50a0490fb3d3795fbda1694977ae526$var$TableVirtualizer(_ref2) {
  var _layout$getLayoutInfo;

  let {
    layout,
    collection,
    focusedKey,
    renderView,
    renderWrapper,
    domRef
  } = _ref2,
      otherProps = _babelRuntimeHelpersEsmObjectWithoutPropertiesLoose(_ref2, ["layout", "collection", "focusedKey", "renderView", "renderWrapper", "domRef"]);

  let {
    direction
  } = useLocale();
  let headerRef = useRef();
  let bodyRef = useRef();
  let state = useVirtualizerState({
    layout,
    collection,
    renderView,
    renderWrapper,

    onVisibleRectChange(rect) {
      bodyRef.current.scrollTop = rect.y;
      setScrollLeft(bodyRef.current, direction, rect.x);
    },

    transitionDuration: collection.body.props.isLoading && collection.size > 0 ? 0 : 500
  });
  let {
    virtualizerProps
  } = useVirtualizer({
    focusedKey,

    scrollToItem(key) {
      let item = collection.getItem(key);
      let column = collection.columns[0];
      state.virtualizer.scrollToItem(key, {
        duration: 0,
        // Prevent scrolling to the top when clicking on column headers.
        shouldScrollY: (item == null ? void 0 : item.type) !== 'column',
        // Offset scroll position by width of selection cell
        // (which is sticky and will overlap the cell we're scrolling to).
        offsetX: column.props.isSelectionCell ? layout.columnWidths.get(column.key) : 0
      });
    }

  }, state, domRef);
  let headerHeight = ((_layout$getLayoutInfo = layout.getLayoutInfo('header')) == null ? void 0 : _layout$getLayoutInfo.rect.height) || 0;
  let visibleRect = state.virtualizer.visibleRect; // Sync the scroll position from the table body to the header container.

  let onScroll = useCallback(() => {
    headerRef.current.scrollLeft = bodyRef.current.scrollLeft;
  }, [bodyRef]);
  let onVisibleRectChange = useCallback(rect => {
    state.setVisibleRect(rect);

    if (!collection.body.props.isLoading && collection.body.props.onLoadMore && state.virtualizer.contentSize.height > rect.height * 2) {
      let scrollOffset = state.virtualizer.contentSize.height - rect.height * 2;

      if (rect.y > scrollOffset) {
        collection.body.props.onLoadMore();
      }
    }
  }, [collection.body.props, state.setVisibleRect, state.virtualizer]);
  return /*#__PURE__*/_react.createElement("div", _babelRuntimeHelpersEsmExtends({}, mergeProps(otherProps, virtualizerProps), {
    ref: domRef
  }), /*#__PURE__*/_react.createElement("div", {
    role: "presentation",
    style: {
      width: visibleRect.width,
      height: headerHeight,
      overflow: 'hidden',
      position: 'relative',
      willChange: state.isScrolling ? 'scroll-position' : '',
      transition: state.isAnimating ? "none " + state.virtualizer.transitionDuration + "ms" : undefined
    },
    ref: headerRef
  }, state.visibleViews[0]), /*#__PURE__*/_react.createElement(ScrollView, {
    role: "presentation",
    className: classNames($a3c51db49654cc69b601457d58d38b1$$interop$default, 'spectrum-Table-body'),
    style: {
      flex: 1
    },
    innerStyle: {
      overflow: 'visible',
      transition: state.isAnimating ? "none " + state.virtualizer.transitionDuration + "ms" : undefined
    },
    ref: bodyRef,
    contentSize: state.contentSize,
    onVisibleRectChange: onVisibleRectChange,
    onScrollStart: state.startScrolling,
    onScrollEnd: state.endScrolling,
    onScroll: onScroll
  }, state.visibleViews[1]));
}

function $a50a0490fb3d3795fbda1694977ae526$var$TableHeader(_ref3) {
  let {
    children
  } = _ref3,
      otherProps = _babelRuntimeHelpersEsmObjectWithoutPropertiesLoose(_ref3, ["children"]);

  let {
    rowGroupProps
  } = useTableRowGroup();
  return /*#__PURE__*/_react.createElement("div", _babelRuntimeHelpersEsmExtends({}, rowGroupProps, otherProps, {
    className: classNames($a3c51db49654cc69b601457d58d38b1$$interop$default, 'spectrum-Table-head')
  }), children);
}

function $a50a0490fb3d3795fbda1694977ae526$var$TableColumnHeader(_ref4) {
  var _state$sortDescriptor, _state$sortDescriptor2, _state$sortDescriptor3, _state$sortDescriptor4;

  let {
    column
  } = _ref4;
  let ref = useRef();
  let state = $a50a0490fb3d3795fbda1694977ae526$var$useTableContext();
  let {
    columnHeaderProps
  } = useTableColumnHeader({
    node: column,
    ref,
    colspan: column.colspan,
    isVirtualized: true
  }, state);
  let columnProps = column.props;
  let {
    hoverProps,
    isHovered
  } = useHover({});
  return /*#__PURE__*/_react.createElement(FocusRing, {
    focusRingClass: classNames($a3c51db49654cc69b601457d58d38b1$$interop$default, 'focus-ring')
  }, /*#__PURE__*/_react.createElement("div", _babelRuntimeHelpersEsmExtends({}, mergeProps(columnHeaderProps, hoverProps), {
    ref: ref,
    className: classNames($a3c51db49654cc69b601457d58d38b1$$interop$default, 'spectrum-Table-headCell', {
      'is-sortable': columnProps.allowsSorting,
      'is-sorted-desc': ((_state$sortDescriptor = state.sortDescriptor) == null ? void 0 : _state$sortDescriptor.column) === column.key && ((_state$sortDescriptor2 = state.sortDescriptor) == null ? void 0 : _state$sortDescriptor2.direction) === 'descending',
      'is-sorted-asc': ((_state$sortDescriptor3 = state.sortDescriptor) == null ? void 0 : _state$sortDescriptor3.column) === column.key && ((_state$sortDescriptor4 = state.sortDescriptor) == null ? void 0 : _state$sortDescriptor4.direction) === 'ascending',
      'is-hovered': isHovered,
      'spectrum-Table-cell--hideHeader': columnProps.hideHeader
    }, classNames($ff2ec5d6c962adaac3d6b55fa22b824a$$interop$default, 'react-spectrum-Table-cell', {
      'react-spectrum-Table-cell--alignCenter': columnProps.align === 'center' || column.colspan > 1,
      'react-spectrum-Table-cell--alignEnd': columnProps.align === 'end'
    }))
  }), columnProps.hideHeader ? /*#__PURE__*/_react.createElement(VisuallyHidden, null, column.rendered) : column.rendered, columnProps.allowsSorting && /*#__PURE__*/_react.createElement(_spectrumIconsUiArrowDownSmall, {
    UNSAFE_className: classNames($a3c51db49654cc69b601457d58d38b1$$interop$default, 'spectrum-Table-sortedIcon')
  })));
}

function $a50a0490fb3d3795fbda1694977ae526$var$TableSelectAllCell(_ref5) {
  let {
    column
  } = _ref5;
  let ref = useRef();
  let state = $a50a0490fb3d3795fbda1694977ae526$var$useTableContext();
  let isSingleSelectionMode = state.selectionManager.selectionMode === 'single';
  let {
    columnHeaderProps
  } = useTableColumnHeader({
    node: column,
    ref,
    colspan: column.colspan,
    isVirtualized: true,
    // Disable click from focusing the div for selectionMode = "single" since there won't be a "Select All" checkbox available
    isDisabled: isSingleSelectionMode
  }, state);
  let {
    checkboxProps
  } = useTableSelectAllCheckbox(state);
  let {
    hoverProps,
    isHovered
  } = useHover({});
  return /*#__PURE__*/_react.createElement(FocusRing, {
    focusRingClass: classNames($a3c51db49654cc69b601457d58d38b1$$interop$default, 'focus-ring')
  }, /*#__PURE__*/_react.createElement("div", _babelRuntimeHelpersEsmExtends({}, mergeProps(columnHeaderProps, hoverProps), {
    "aria-disabled": isSingleSelectionMode,
    ref: ref,
    className: classNames($a3c51db49654cc69b601457d58d38b1$$interop$default, 'spectrum-Table-headCell', 'spectrum-Table-checkboxCell', {
      'is-hovered': isHovered
    })
  }), /*#__PURE__*/_react.createElement(Checkbox, _babelRuntimeHelpersEsmExtends({}, checkboxProps, {
    isDisabled: isSingleSelectionMode,
    isEmphasized: true,
    UNSAFE_style: {
      visibility: isSingleSelectionMode ? 'hidden' : 'visible'
    },
    UNSAFE_className: classNames($a3c51db49654cc69b601457d58d38b1$$interop$default, 'spectrum-Table-checkbox')
  }))));
}

function $a50a0490fb3d3795fbda1694977ae526$var$TableRowGroup(_ref6) {
  let {
    children
  } = _ref6,
      otherProps = _babelRuntimeHelpersEsmObjectWithoutPropertiesLoose(_ref6, ["children"]);

  let {
    rowGroupProps
  } = useTableRowGroup();
  return /*#__PURE__*/_react.createElement("div", _babelRuntimeHelpersEsmExtends({}, rowGroupProps, otherProps), children);
}

function $a50a0490fb3d3795fbda1694977ae526$var$TableRow(_ref7) {
  let {
    item,
    children
  } = _ref7,
      otherProps = _babelRuntimeHelpersEsmObjectWithoutPropertiesLoose(_ref7, ["item", "children"]);

  let ref = useRef();
  let state = $a50a0490fb3d3795fbda1694977ae526$var$useTableContext();
  let isDisabled = state.disabledKeys.has(item.key);
  let isSelected = state.selectionManager.isSelected(item.key) && !isDisabled;
  let {
    rowProps
  } = useTableRow({
    node: item,
    isSelected,
    ref,
    isVirtualized: true,
    isDisabled
  }, state); // The row should show the focus background style when any cell inside it is focused.
  // If the row itself is focused, then it should have a blue focus indicator on the left.

  let {
    isFocusVisible: isFocusVisibleWithin,
    focusProps: focusWithinProps
  } = useFocusRing({
    within: true
  });
  let {
    isFocusVisible,
    focusProps
  } = useFocusRing();
  let {
    hoverProps,
    isHovered
  } = useHover({
    isDisabled
  });
  let props = mergeProps(rowProps, otherProps, focusWithinProps, focusProps, hoverProps);
  return /*#__PURE__*/_react.createElement("div", _babelRuntimeHelpersEsmExtends({}, props, {
    ref: ref,
    className: classNames($a3c51db49654cc69b601457d58d38b1$$interop$default, 'spectrum-Table-row', {
      'is-selected': isSelected,
      'is-focused': isFocusVisibleWithin,
      'focus-ring': isFocusVisible,
      'is-hovered': isHovered,
      'is-disabled': isDisabled
    })
  }), children);
}

function $a50a0490fb3d3795fbda1694977ae526$var$TableHeaderRow(_ref8) {
  let {
    item,
    children
  } = _ref8,
      otherProps = _babelRuntimeHelpersEsmObjectWithoutPropertiesLoose(_ref8, ["item", "children"]);

  // TODO: move to react-aria?
  return /*#__PURE__*/_react.createElement("div", _babelRuntimeHelpersEsmExtends({
    role: "row",
    "aria-rowindex": item.index + 1
  }, otherProps), children);
}

function $a50a0490fb3d3795fbda1694977ae526$var$TableCheckboxCell(_ref9) {
  let {
    cell
  } = _ref9;
  let ref = useRef();
  let state = $a50a0490fb3d3795fbda1694977ae526$var$useTableContext();
  let isDisabled = state.disabledKeys.has(cell.parentKey);
  let {
    gridCellProps
  } = useTableCell({
    node: cell,
    ref,
    isVirtualized: true,
    isDisabled
  }, state);
  let {
    checkboxProps
  } = useTableSelectionCheckbox({
    key: cell.parentKey,
    isDisabled
  }, state);
  return /*#__PURE__*/_react.createElement(FocusRing, {
    focusRingClass: classNames($a3c51db49654cc69b601457d58d38b1$$interop$default, 'focus-ring')
  }, /*#__PURE__*/_react.createElement("div", _babelRuntimeHelpersEsmExtends({}, gridCellProps, {
    ref: ref,
    className: classNames($a3c51db49654cc69b601457d58d38b1$$interop$default, 'spectrum-Table-cell', 'spectrum-Table-checkboxCell', {
      'is-disabled': isDisabled
    }, classNames($ff2ec5d6c962adaac3d6b55fa22b824a$$interop$default, 'react-spectrum-Table-cell'))
  }), state.selectionManager.selectionMode !== 'none' && /*#__PURE__*/_react.createElement(Checkbox, _babelRuntimeHelpersEsmExtends({}, checkboxProps, {
    isEmphasized: true,
    isDisabled: isDisabled,
    UNSAFE_className: classNames($a3c51db49654cc69b601457d58d38b1$$interop$default, 'spectrum-Table-checkbox')
  }))));
}

function $a50a0490fb3d3795fbda1694977ae526$var$TableCell(_ref10) {
  let {
    cell
  } = _ref10;
  let ref = useRef();
  let state = $a50a0490fb3d3795fbda1694977ae526$var$useTableContext();
  let isDisabled = state.disabledKeys.has(cell.parentKey);
  let {
    gridCellProps
  } = useTableCell({
    node: cell,
    ref,
    isVirtualized: true,
    isDisabled
  }, state);
  return /*#__PURE__*/_react.createElement($a50a0490fb3d3795fbda1694977ae526$var$TableCellBase, _babelRuntimeHelpersEsmExtends({}, gridCellProps, {
    cell: cell,
    cellRef: ref
  }));
}

function $a50a0490fb3d3795fbda1694977ae526$var$TableRowHeader(_ref11) {
  let {
    cell
  } = _ref11;
  let ref = useRef();
  let state = $a50a0490fb3d3795fbda1694977ae526$var$useTableContext();
  let isDisabled = state.disabledKeys.has(cell.parentKey);
  let {
    rowHeaderProps
  } = useTableRowHeader({
    node: cell,
    ref,
    isVirtualized: true,
    isDisabled
  }, state);
  return /*#__PURE__*/_react.createElement($a50a0490fb3d3795fbda1694977ae526$var$TableCellBase, _babelRuntimeHelpersEsmExtends({}, rowHeaderProps, {
    cell: cell,
    cellRef: ref
  }));
}

function $a50a0490fb3d3795fbda1694977ae526$var$TableCellBase(_ref12) {
  let {
    cell,
    cellRef
  } = _ref12,
      otherProps = _babelRuntimeHelpersEsmObjectWithoutPropertiesLoose(_ref12, ["cell", "cellRef"]);

  let state = $a50a0490fb3d3795fbda1694977ae526$var$useTableContext();
  let columnProps = cell.column.props;
  let isDisabled = state.disabledKeys.has(cell.parentKey);
  return /*#__PURE__*/_react.createElement(FocusRing, {
    focusRingClass: classNames($a3c51db49654cc69b601457d58d38b1$$interop$default, 'focus-ring')
  }, /*#__PURE__*/_react.createElement("div", _babelRuntimeHelpersEsmExtends({}, otherProps, {
    ref: cellRef,
    className: classNames($a3c51db49654cc69b601457d58d38b1$$interop$default, 'spectrum-Table-cell', {
      'spectrum-Table-cell--divider': columnProps.showDivider,
      'spectrum-Table-cell--hideHeader': columnProps.hideHeader,
      'is-disabled': isDisabled
    }, classNames($ff2ec5d6c962adaac3d6b55fa22b824a$$interop$default, 'react-spectrum-Table-cell', {
      'react-spectrum-Table-cell--alignCenter': columnProps.align === 'center',
      'react-spectrum-Table-cell--alignEnd': columnProps.align === 'end'
    }))
  }), /*#__PURE__*/_react.createElement("span", {
    className: classNames($a3c51db49654cc69b601457d58d38b1$$interop$default, 'spectrum-Table-cellContents')
  }, cell.rendered)));
}

function $a50a0490fb3d3795fbda1694977ae526$var$CenteredWrapper(_ref13) {
  let {
    children
  } = _ref13;
  let state = $a50a0490fb3d3795fbda1694977ae526$var$useTableContext();
  return /*#__PURE__*/_react.createElement("div", {
    role: "row",
    "aria-rowindex": state.collection.headerRows.length + state.collection.size + 1,
    className: classNames($ff2ec5d6c962adaac3d6b55fa22b824a$$interop$default, 'react-spectrum-Table-centeredWrapper')
  }, /*#__PURE__*/_react.createElement("div", {
    role: "rowheader",
    "aria-colspan": state.collection.columns.length
  }, children));
}

export const Table = _react.forwardRef($a50a0490fb3d3795fbda1694977ae526$var$Table);
// Override TS for Column to support spectrum specific props.
export const Column = _Column;
//# sourceMappingURL=module.js.map
